/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateUserContractCommand } from '../../models/create-user-contract-command';
import { Int32ApiResponse } from '../../models/int-32-api-response';

export interface CreateUserContractAsync$Params {
  id: number;
      body?: CreateUserContractCommand
}

export function createUserContractAsync(http: HttpClient, rootUrl: string, params: CreateUserContractAsync$Params, context?: HttpContext): Observable<StrictHttpResponse<Int32ApiResponse>> {
  const rb = new RequestBuilder(rootUrl, createUserContractAsync.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Int32ApiResponse>;
    })
  );
}

createUserContractAsync.PATH = '/api/user/{id}/contract';
